/**
  * @desc create a time in milliseconds to increase expire data from now.
  *
  * @param {tms} tms time in milliseconds to add at time.now(), default
  * value is 3600 --> 1 hour
  *
  * @returns {date} date that could be put on cookies
*/
function calculateExpireTimeFromNow({ tms = 3600 }) {
  const now = new Date();
  let time = now.getTime();
  time += tms * 1000;
  now.setTime(time);
  return now;
}
export default calculateExpireTimeFromNow;
